// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__qBOkp","legacyBtn":"MutateMid_legacyBtn__1lZeH"};